import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import Text from '@/src/components/Modules-revamp/ImageAndPoster/Text';
import { Field } from '@/src/components/RcForm';
import { ResponsiveContainer, ResponsiveField } from '@/src/strategies/util';
import { get } from 'lodash';
import React from 'react';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import textRenderTemplate from 'src/strategies/render/text';
import moduleStyleRender from '../../ModuleStyle';

import FieldCheckbox from '@/src/components/Modules-revamp/FieldCheckbox';
import { h1TagEnabled } from '@/src/tools/contentModulesFieldName';
import { useText } from '../../hooks/useText';
import { checkResponsiveText } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';

type ResponsiveFieldProps = {
  field: ResponsiveField | ResponsiveField[];
  disabled?: boolean;
  options?: Array<{ label: string; value: any }>;
  hasModal?: boolean;
  modalFunc?: any;
};
const textComponent = (
  data: ResponsiveFieldProps,
  breakpoint: any,
  extra: any,
) => {
  const { textValidator } = extra;
  switch (data.field) {
    case ResponsiveField.H1Tag: {
      return (
        <FieldCheckbox
          title={<>&nbsp;</>}
          label='Set as page H1 tag'
          name={h1TagEnabled}
          disabled={data?.disabled}
        />
      );
    }
    case ResponsiveField.RichText: {
      return (
        <Text
          disabled={data?.disabled}
          breakpoint={breakpoint}
          validator={textValidator}
        />
      );
    }
    default:
      return;
  }
};
const textRender = (form: any, breakpoint: any, extra: any) => {
  const values = form.getFieldsValue(true);
  const { handleOnSectionReset, handleOnSectionCopy } = extra;
  const list = textRenderTemplate(values, breakpoint);
  const renderComponents = (
    {
      type,
      field,
    }: {
      title?: string;
      titleHide?: boolean;
      type?: ResponsiveContainer;
      field: Array<any>;
    },
    breakpoint: any,
  ) => {
    if (type === ResponsiveContainer.ModuleStyle) {
      return field.map((f) => moduleStyleRender(f));
    } else {
      return field.map((f) => textComponent(f, breakpoint, extra));
    }
  };
  return (
    <>
      {list.map((item, index) => {
        const component = renderComponents(item, breakpoint);
        return (
          <>
            {item?.titleHide ? (
              component
            ) : (
              <Wrapper
                key={`${item.title}_${index}`}
                id={`${item?.id}`}
                breakpoint={breakpoint}>
                <BlockTitle
                  id={item?.id}
                  title={item?.title}
                  breakpoint={breakpoint}
                  onReset={() =>
                    handleOnSectionReset(item?.fields, breakpoint, { item })
                  }
                  onCopy={() =>
                    handleOnSectionCopy(item?.fields, breakpoint, { item })
                  }
                  dependencies={get(item, 'dependencies')}
                  validator={get(item, 'validator')}
                />

                {component}
              </Wrapper>
            )}
          </>
        );
      })}
    </>
  );
};

export default ({ form, breakpoint, ...extra }: any) => {
  // TODO: 这里要变
  const { handleOnModalConfirm, handleOnAdd, handleOnDelete, handleOnSort } =
    useText({ form });
  const { checkContentText } = checkResponsiveText();
  return (
    <Field shouldUpdate>
      {() =>
        textRender(form, breakpoint, {
          onModalConfirm: handleOnModalConfirm,
          onAdd: handleOnAdd,
          onDelete: handleOnDelete,
          onSort: handleOnSort,
          form,
          ...extra,
          textValidator: checkContentText,
        })
      }
    </Field>
  );
};
